import { Box, Heading, Text } from '@razorpay/blade/components';
import { SalaryStructureProvider } from './context/SalaryStructureProvider';
import { SalaryStructureTable } from './SalaryStructureTable';

const SalaryStructure = () => {
  return (
    <SalaryStructureProvider>
      <Box display="grid" placeItems="center" padding="spacing.10">
        <Box padding="spacing.6" maxWidth="768px" width="100%">
          <Heading size="large" weight="semibold" marginBottom="spacing.3">
            Default Salary Structure
          </Heading>
          <Text
            size="medium"
            weight="regular"
            color="surface.text.gray.muted"
            marginBottom="spacing.6">
            Default salary structure is applied to all the employees of the organisation
          </Text>
          <SalaryStructureTable />
        </Box>
      </Box>
    </SalaryStructureProvider>
  );
};

export default SalaryStructure;
